import { A11y, EffectCards } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-cards';
import { IReview } from './reviewsBlock.types';
import Image from 'next/image';
import cn from 'classnames';
import { roboto } from '@trwl/app/fonts';
import { Button } from '@trwl/shared/ui/button';
import Link from 'next/link';
import { ym } from '@trwl/util';

interface IReviewsBlock {
  reviews: IReview[];
}

export const ReviewsBlock = ({ reviews }: IReviewsBlock) => {
  return (
    <div
      id={'reviewsBlock'}
      className={
        'relative grid grid-cols-1 lg:grid-cols-2 w-full justify-between gap-8 overflow-hidden'
      }
    >
      <div
        id={'reviews'}
        className={'absolute -top-[130px] invisible'}
        aria-hidden="true"
      />
      <div
        className={
          'flex flex-col items-center justify-center gap-6 order-2 lg:-order-1'
        }
      >
        <div
          className={
            'text-center font-normal text-md min-[420px]:text-xl leading-7 xl:text-2xl xl:leading-10'
          }
        >
          Делитесь своим опытом работы с нами, <br />
          чтобы сервис становился лучше. <br />
          Мы всегда рады обратной связи!
        </div>
        <Button
          as={Link}
          onPress={() => ym('all-reviews-button')}
          href="https://t.me/feedbackTRWL"
          target="_blank"
          size="lg"
          radius="sm"
          color="primary"
          className="whitespace-nowrap min-w-[250px]"
        >
          Все отзывы
        </Button>
      </div>
      <div className={'py-4'}>
        <Swiper
          effect={'cards'}
          grabCursor={true}
          modules={[EffectCards, A11y]}
          className="mySwiper w-[210px] min-[340px]:w-[250px] md:w-[300px] mx-auto"
        >
          {reviews.map((review: IReview, index) => (
            <SwiperSlide
              className={
                'flex flex-col items-center justify-center bg-[#22211b] overflow-hidden rounded-[12px] select-none pb-1'
              }
              key={index}
            >
              <Image
                className={
                  'w-full h-[40vw] max-h-[400px] min-h-[280px] object-cover'
                }
                src={review.imageURL}
                alt={`Отзыв #${index}`}
                height={400}
                width={300}
                priority={index === 0}
              />
              <div className={'px-3 py-2 text-white font-thin min-h-[90px]'}>
                <div
                  className={cn(
                    'w-full overflow-ellipsis line-clamp-3',
                    roboto.className,
                  )}
                >
                  {review.text}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <br />
        <div className="hidden shadow-md pl-2 pr-3 py-0.5 rounded-[10px] w-[210px] md:w-[300px] mx-auto items-center gap-4 cursor-pointer duration-300 md:hover:scale-[1.03]">
          <Image
            width={70}
            height={70}
            alt={''}
            src={
              'https://cdn.poizon.com/pro-img/origin-img/20240415/f2a55d5c3df84527af91fe3c5b807a60.jpg?x-oss-process=image/resize,h_1200,w_1200,m_pad'
            }
            className={'w-[40px] h-[40px] md:w-[50px] md:h-[50px]'}
            loading={'lazy'}
          />
          <div>
            <div className={'text-sm md:text-md font-thin line-clamp-1'}>
              Adidas Campus 00s Bark
            </div>
            <div className={'text-md'}>21.290 ₽</div>
          </div>
        </div>
      </div>
    </div>
  );
};
